export const publicQuestions = ({ publicProfileReducer: { publicQuestionsData } }) =>
	publicQuestionsData;
export const publicAnswers = ({ publicProfileReducer: { publicAnswersData } }) => publicAnswersData;
